import { ADMIN_FUNCTIONS, SC_MODULES } from '@app/constants/sc.modules';
import myIcon from '@app/assets/images/icons/sys/school.svg';
import Organization from '@modules/school-service/pages/OrganizationPage';
import { IRouteConfig } from '../route.types';

const organizationRoutes: IRouteConfig[] = [
    {
        name: 'DANH SÁCH ĐƠN VỊ',
        icon: myIcon,
        isMenu: true,
        isRoute: true,
        exact: false,
        moduleId: SC_MODULES.SERVICE,
        link: '/organization',
        path: '/organization',
        main: () => <Organization />,
        functionId: ADMIN_FUNCTIONS.ORGANIZATIONS,
    },
];

export default organizationRoutes;
